import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Vehiculos from './pages/Vehiculos';
import Ordenes from './pages/Ordenes';
import Usuarios from './pages/Usuarios';
import Contratos from './pages/Contratos';
import FirmaContrato from './pages/FirmaContrato';
import DashboardOperativo from './pages/DashboardOperativo';
import VehiculoDetalle from './pages/VehiculoDetalle';
import ClienteDetalle from './pages/ClienteDetalle';
import GPS from './pages/GPS';
import Lineas from './pages/Lineas';
import HSSVision from './pages/HSSVision';
import Settings from './pages/Settings';
import FirmaChecklist from './pages/FirmaChecklist';
import UsuariosClientes from './pages/UsuariosClientes';
import AuditLog from './pages/AuditLog';
import Reportes from './pages/Reportes';
import DashboardGerencial from './pages/DashboardGerencial';
import Agenda from './pages/Agenda';
import Accesorios from './pages/Accesorios';
import Mapa from './pages/Mapa';
import AccesorioDetalle from './pages/AccesorioDetalle';
import AppLayout from './components/AppLayout';
import { ConfigProvider } from 'antd';
import { antdTheme } from './config/theme';

const W = ({ children }) => <AppLayout>{children}</AppLayout>;

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <Routes>
        {/* Páginas públicas — sin sidebar */}
        <Route path="/" element={<Login />} />
        <Route path="/firma/:token" element={<FirmaContrato />} />
        <Route path="/checklist/firma/:token" element={<FirmaChecklist />} />

        {/* Páginas internas — con sidebar */}
        <Route path="/dashboard"           element={<W><Dashboard /></W>} />
        <Route path="/clientes"            element={<W><Clientes /></W>} />
        <Route path="/clientes/:dni"       element={<W><ClienteDetalle /></W>} />
        <Route path="/vehiculos"           element={<W><Vehiculos /></W>} />
        <Route path="/vehiculos/:chapa"    element={<W><VehiculoDetalle /></W>} />
        <Route path="/ordenes"             element={<W><Ordenes /></W>} />
        <Route path="/usuarios"            element={<W><Usuarios /></W>} />
        <Route path="/contratos"           element={<W><Contratos /></W>} />
        <Route path="/operativo"           element={<W><DashboardOperativo /></W>} />
        <Route path="/gps"                 element={<W><GPS /></W>} />
        <Route path="/lineas"              element={<W><Lineas /></W>} />
        <Route path="/vision"              element={<W><HSSVision /></W>} />
        <Route path="/settings"            element={<W><Settings /></W>} />
        <Route path="/usuarios-clientes"   element={<W><UsuariosClientes /></W>} />
        <Route path="/audit-log"           element={<W><AuditLog /></W>} />
        <Route path="/reportes"            element={<W><Reportes /></W>} />
        <Route path="/dashboard-gerencial" element={<W><DashboardGerencial /></W>} />
        <Route path="/agenda"              element={<W><Agenda /></W>} />
        <Route path="/mapa"                element={<W><Mapa /></W>} />
        <Route path="/accesorios"          element={<W><Accesorios /></W>} />
        <Route path="/accesorios/:id"      element={<W><AccesorioDetalle /></W>} />
      </Routes>
    </ConfigProvider>
  );
}

export default App; 